import React from 'react';

import {connect} from "react-redux";
import * as contactUtils from "../../utils/clientContact";
import l10n from "../../l10n/localization";
import * as contactActions from "../../actions/clientContact";
import Loader from "../common/Loader";
import Validate from 'validate.js';
import validation from '../../validation/clientContact';
import * as utilsCommon from "../../utils/utils";
import CWForm from "./CWForm";
import Checkbox from "./fields/Checkbox";

class ClientContactForm extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            item: utilsCommon.notNullNorUndefined(this.props.item.item) ? this.props.contacts.getById(this.props.item.item.id) : null,
            client: this.props.item.client,
            schema: {
                type: "object",
                properties: {
                    name: {
                        type: "string",
                        title: l10n.contact.name
                    },
                    email: {
                        type: "string",
                        title: l10n.contact.email,
                    },
                    phone: {
                        type: "string",
                        title: l10n.contact.phone
                    },
                    mobile: {
                        type: "string",
                        title: l10n.contact.mobile
                    },
                    fax: {
                        type: "string",
                        title: l10n.contact.fax
                    },
                    mainContact: {
                        type: "boolean",
                        title: l10n.contact.mainContact
                    }
                }
            },
            uiSchema: {
                mainContact: {
                    "ui:field": "checkbox",
                }
            },
            fields: {
                checkbox: Checkbox,
            },
            isDirty: false,
            formData: contactUtils.clientContactToForm(utilsCommon.notNullNorUndefined(this.props.item.item) ? this.props.contacts.getById(this.props.item.item.id) : null)
        }
    }

    onSubmit = ({formData}) => {
        let form = Object.assign({}, {...formData});

        if (utilsCommon.notNullNorUndefined(this.state.item) && (utilsCommon.notNullNorUndefined(this.state.item.id) || utilsCommon.notNullNorUndefined(this.props.newlyCreatedElement))) {
            if (utilsCommon.notNullNorUndefined(this.props.newlyCreatedElement)) {
                this.setState({item: {...formData, id: this.props.newlyCreatedElement}}, () => {
                    form.id = this.props.newlyCreatedElement;
                    this.props.dispatch(contactActions.edit(form, this.state.client.id));
                })
            } else {
                this.setState({item: formData}, () => {
                    this.props.dispatch(contactActions.edit(form, this.state.client.id));
                })
            }
        } else {
            this.setState({item: formData}, () => {
                form.client = this.state.client.id;
                this.props.dispatch(contactActions.add(form, this.state.client.id));
            })
        }
        this.setState((state) => {return {...state, isDirty: false, formData:formData};});
    };

    validate = (formData, errors) => {
        let validationErrors = Validate(formData, validation, {fullMessages: false});

        if (validationErrors !== undefined) {
            for (let key in validationErrors) {
                if (validationErrors.hasOwnProperty(key)) {
                    if (errors[key] !== undefined) {
                        for (let i = 0; i < validationErrors[key].length; i++) {
                            errors[key].addError(validationErrors[key][i]);
                        }
                    }
                }
            }
        }
        return errors;
    };

    handleChange = (formData) => {
        let nextState = this.state;

        if(!this.state.isDirty) {
            nextState.isDirty = true;
        }
        nextState.formData = formData.formData;
        this.setState((state) => {return {...state, nextState}});
    };

    handleError = () => {
        this.props.dispatch(contactActions.errorMessage(l10n.validation.form_error));
    };

    render() {
        if (this.props.loading) {
            return (<div><Loader /></div>)
        }
        let formClassName = (this.state.isDirty) ? 'company-form dirty':'company-form';

        return (
            <div className={formClassName}>
                <h1>{l10n.common.contacts}</h1>
                <CWForm
                    schema={this.state.schema}
                    uiSchema={this.state.uiSchema}
                    formData={this.state.formData}
                    showErrorList={false}
                    validate={this.validate}
                    liveValidate={true}
                    onSubmit={this.onSubmit}
                    onError={this.handleError}
                    onChange={({formData})=> {this.handleChange({formData})}}
                    fields={this.state.fields}>
                    <div>
                        <button type="submit" className="btn btn-info validate" disabled={this.props.saving}>{l10n.common.save}</button>
                    </div>
                </CWForm>
            </div>
        )
    }
}

export default connect((state) => {
    return Object.assign({}, {
        saving: state.clientContact.saving,
        contacts: state.clientContact.contacts,
        newlyCreatedElement: state.creation.newlyCreatedClientContact,
    });
})(ClientContactForm);


// WEBPACK FOOTER //
// ./src/components/forms/ClientContactForm.js